<template>
    <div :class="cn(alertDivVariants({ variant }), $attrs.class ?? '')">
        <div :class="alertLogoWrapperVariants({ variant })">
            <AlertCircle :size="20" :class="alertLogoVariants({ variant })" />
        </div>
        <p :class="alertTextariants({ variant })">
            <slot />
        </p>
    </div>
</template>

<script lang="ts" setup>
import { AlertCircle } from "lucide-vue-next";

import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

interface Props {
    variant?: "info" | "error";
}
const { variant = "info" } = defineProps<Props>();

const alertDivVariants = cva("mt-6 flex gap-4 rounded-lg border p-4", {
    variants: {
        variant: {
            info: "border-[#7CD4FD] bg-[#F5FBFF]",
            error: "border-error-200 bg-error-25",
            warning: "",
        },
    },
    defaultVariants: {
        variant: "info",
    },
});

const alertLogoWrapperVariants = cva(
    "flex h-8 w-8 shrink-0 items-center justify-center rounded-full ",
    {
        variants: {
            variant: {
                info: "bg-[#E0F2FE]",
                error: "bg-error-100",
                warning: "",
            },
        },
        defaultVariants: {
            variant: "info",
        },
    },
);

const alertLogoVariants = cva("", {
    variants: {
        variant: {
            info: "text-[#026AA2]",
            error: "text-error-600",
            warning: "",
        },
    },
    defaultVariants: {
        variant: "info",
    },
});

const alertTextariants = cva("text-sm", {
    variants: {
        variant: {
            info: "text-[#026AA2]",
            error: "text-error-700",
            warning: "",
        },
    },
    defaultVariants: {
        variant: "info",
    },
});
</script>
